<script lang="ts">
	import { patchSettingPaymentPeriodValue } from '../../../../api/EnzianSettingsApi';
	import Deletable from '../../../../basic/Deletable.svelte';
	import DefaultBigInput from '../../../../basic/input/DefaultBigInput.svelte';
	import DefaultNumberInput from '../../../../basic/input/DefaultNumberInput.svelte';
	import DefaultTextInput from '../../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../../basic/input/InputLabel.svelte';
	import type { PatchSettingPaymentPeriodValue, SettingPaymentPeriodValue } from '../../../../types/BasicTypes';
	import Big from 'big.js';
	import { _ } from 'svelte-i18n';

	interface Props {
		paymentPeriodValue: SettingPaymentPeriodValue;
		onDeleteRequest: (item: SettingPaymentPeriodValue) => void;
	}

	let { paymentPeriodValue = $bindable(), onDeleteRequest }: Props = $props();

	async function handlePatch(object: PatchSettingPaymentPeriodValue) {
		//Send the patch request
		await patchSettingPaymentPeriodValue(paymentPeriodValue.id, object);
	}
</script>

<Deletable
	onDelete={() => {
		onDeleteRequest(paymentPeriodValue);
	}}
>
	<div class="grid grid-cols-3 gap-2">
		<div class="flex items-center gap-2">
			<InputLabel label={$_('settings.basic.payment_periods.values.lbl_name') + ':'} />
			<DefaultTextInput
				propertyName={'name'}
				bind:value={paymentPeriodValue.name}
				callFunction={handlePatch}
			/>
		</div>
		<div class="flex items-center gap-2 border-l-2 py-2">
			<InputLabel label={$_('settings.basic.payment_periods.values.lbl_payment_days') + ':'} />
			<DefaultNumberInput
				propertyName={'days'}
				min={0}
				bind:value={paymentPeriodValue.days}
				callFunction={handlePatch}
			/>
		</div>
		<div class="flex items-center gap-2 border-l-2 py-2">
			<InputLabel label={$_('settings.basic.payment_periods.values.lbl_percentage') + ':'} />
			<DefaultBigInput
				propertyName={'percentage'}
				max={new Big(100)}
				min={new Big(0)}
				bind:value={paymentPeriodValue.percentage}
				callFunction={handlePatch}
			/>
		</div>
	</div>
</Deletable>
